module.exports = __webpack_public_path__ + "img/3.4e5f5688.jpg";